// finds if a specific class is parent of our element, and if so returns it
export const validateIfParentExists = (el, className) => {
	while (el && el.parentNode) {
		el = el.parentNode
		if (el.className && el.className.toLowerCase().includes(className)) {
			return el
		}
	}

	// Many DOM methods return null if they don't find the element they are searching for
	return null
}

/**
@firstEmptyFieldIdentifier {String} - element Id
@returns {Number} - value of offset top of element
*/
export const getElementOffsetTopPosition = (firstEmptyFieldIdentifier) => {
	if (!document.getElementById(firstEmptyFieldIdentifier)) return 0
	return document.getElementById(firstEmptyFieldIdentifier).offsetTop
}

/**
* checks if it is in view, if not moves scroll to show element
@container {DOM element}
@element {DOM element}
@returns {void}
*/
export const checkIfElementIsVisible = (container, keyboardHeight) => {
	/* Determine container top and bottom */
	const containerTop = container.getBoundingClientRect().top
	const containerBottom = containerTop + container.clientHeight
	const parentWithScroll = validateIfParentExists(container, 'features-base-content-wrapper')
	const footerHeight = validateIfParentExists(container, 'showing-footer') ? 62 : 0

	if (window.cordova?.platformId === 'ios') {
		const closeKeyboardHeight = 336
		const elementIsHidden = (window.fullMobileHeight - closeKeyboardHeight) < containerBottom

		if (parentWithScroll && elementIsHidden) {
			const currentScrollTop = parentWithScroll.scrollTop

			setTimeout(() => {
				parentWithScroll.scrollTop = currentScrollTop + (containerBottom - 360)
			}, 200)
		}
		return
	}

	const elementIsHidden = window.innerHeight - parseInt(keyboardHeight) < containerBottom

	if (parentWithScroll && elementIsHidden) {
		const currentScrollTop = parentWithScroll.scrollTop

		setTimeout(() => {
			parentWithScroll.scrollTop = currentScrollTop + keyboardHeight + footerHeight
		}, 200)
	}
}
